import React from 'react'
import PropTypes from 'prop-types'
import clsx from 'clsx'
import { Megaphone, Sparkle, TrendUp, Wrench } from '@phosphor-icons/react'
import { UPDATE_TYPE, getUpdateTypeKey } from './constants'
import { useThumbnailStyles } from './styles'

const ICON_BY_TYPE = {
  [UPDATE_TYPE.FEATURE]: Sparkle,
  [UPDATE_TYPE.IMPROVEMENT]: TrendUp,
  [UPDATE_TYPE.FIX]: Wrench,
  [UPDATE_TYPE.ANNOUNCEMENT]: Megaphone
}

/**
 * The note's thumbnail, or a flat tile in the type's tint with the type icon
 * when there is none, so a list of notes with and without images still lines
 * up. Decorative: the title next to it carries the meaning.
 */
export const WhatsNewThumbnail = ({ announcement, width = 200, height = 113, iconSize = 36, dataTest }) => {
  const tone = getUpdateTypeKey(announcement?.type)
  const classes = useThumbnailStyles()
  const Icon = ICON_BY_TYPE[tone]

  return (
    // Width and height are the caller's dimensions, not a look: they stay inline.
    <div className={clsx(classes.root, classes[tone])} style={{ width, height }} data-test={dataTest} aria-hidden='true'>
      {announcement?.image?.imgUrl
        ? <img src={announcement.image.imgUrl} alt='' className={classes.image} loading='lazy' />
        : <Icon size={iconSize} weight='duotone' />}
    </div>
  )
}

WhatsNewThumbnail.propTypes = {
  announcement: PropTypes.shape({
    type: PropTypes.string,
    image: PropTypes.shape({ imgUrl: PropTypes.string })
  }),
  width: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  height: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  iconSize: PropTypes.number,
  dataTest: PropTypes.string
}
